// extracted by mini-css-extract-plugin
export default {"requestFormEdit":"eqHTcXaSjs211vrD7UCD","columns":"DXTvZzy9uJkfGpaDMdvP","card":"UELSbL94iaupC04jBHxf","published":"m8yPsFNvKW53ZQ4GLD04"};